// CSS entry file
require('./assets/styles/_entry.scss');

// JS entry file
require('./assets/js/_entry.js');

